import { Route, Routes } from 'react-router-dom'

import { LoginWithTwoFA } from '../login/TwoFactorAuthentication/LoginWithTwoFA/LoginWithTwoFA'
import { LoginWithRecoveryCodeContainer } from '../login/TwoFactorAuthentication/LoginWithRecoveryCode/LoginWithRecoveryCodeContainer'

import { Login } from '@percent/admin-dashboard/app/login/Login'
import { TwoFactorAuthenticationSetup } from '@percent/admin-dashboard/app/login/TwoFactorAuthentication/TwoFactorAuthenticationSetup'
import { ForgotPassword } from '@percent/admin-dashboard/app/forgotPassword/ForgotPassword'
import { SetPassword } from '@percent/admin-dashboard/app/setPassword/SetPassword'
import { ExpiredSessionHandle } from '@percent/admin-dashboard/app/expiredSessionHandle/ExpiredSessionHandle'
import { AuthorisedRoutes } from './AuthorisedRoutes'

export function UnprotectedRoutes() {
  return (
    <Routes>
      <Route element={<Login />} path="/login" />
      <Route element={<LoginWithRecoveryCodeContainer />} path="/login/2fa-recovery" />
      <Route element={<ForgotPassword />} path="/forgot-password" />
      <Route element={<SetPassword />} path="/set-password" />
      <Route element={<LoginWithTwoFA />} path="/login/2fa" />
      <Route element={<TwoFactorAuthenticationSetup />} path="/login/2fa-setup" />
      <Route element={<ExpiredSessionHandle />} path="/expired-session" />
      {AuthorisedRoutes()}
    </Routes>
  )
}
